import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function hideDeclineFraudReviewDialog(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_DECLINE_FRAUD_REVIEW_DIALOG, { show: false });
}
